export default __webpack_public_path__ + "static/media/header.d4aabe16.jpg";